
import { supabase } from "@/integrations/supabase/client";

export const logSecurityAction = async (
  actionType: string,
  resource: string,
  entityId: string,
  details: any = {},
  status: 'success' | 'failure' = 'success'
) => {
  try {
    const { error } = await supabase.from('security_logs').insert({
      action_type: actionType,
      resource,
      entity_id: entityId,
      details,
      status
    });
    
    if (error) throw error;
    return true;
  } catch (error) {
    console.error("Failed to log security action:", error);
    return false;
  }
};

export const getSecurityLogs = async (filters: {
  actionType?: string;
  userId?: string;
  dateFrom?: Date;
  dateTo?: Date;
}) => {
  try {
    let query = supabase
      .from('security_logs')
      .select(`
        id,
        user_id,
        action_type,
        timestamp,
        resource,
        entity_id,
        status,
        details,
        profiles(name)
      `)
      .order('timestamp', { ascending: false });
    
    if (filters.actionType) {
      query = query.ilike('action_type', `%${filters.actionType}%`);
    }
    
    if (filters.userId) {
      query = query.eq('user_id', filters.userId);
    }
    
    if (filters.dateFrom) {
      query = query.gte('timestamp', filters.dateFrom.toISOString());
    }
    
    if (filters.dateTo) {
      // Add a day to include the entire day
      const nextDay = new Date(filters.dateTo);
      nextDay.setDate(nextDay.getDate() + 1);
      query = query.lt('timestamp', nextDay.toISOString());
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    return data.map(log => {
      // Fix TypeScript error by using optional chaining and non-null assertion for type safety
      const profiles = log.profiles as { name?: string } | null;
      const profileName = profiles?.name ?? log.user_id;
                         
      return {
        id: log.id,
        userId: log.user_id,
        userName: profileName,
        actionType: log.action_type,
        timestamp: log.timestamp,
        resource: log.resource,
        // Ensure status is explicitly cast to the required type
        status: log.status as "success" | "failure",
        details: log.details,
        entity_id: log.entity_id
      };
    });
  } catch (error) {
    console.error("Failed to fetch security logs:", error);
    return [];
  }
};
